import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Aggressively remove any platform attribution badges/widgets
const removeExternalWidgets = () => {
  const selectors = [
    '[id*="intercom"]',
    '[class*="intercom"]',
    'iframe[name*="intercom"]',
    '[id*="emergent"]',
    '[class*="emergent"]',
    'iframe[src*="intercom"]',
    '.intercom-lightweight-app',
    '.intercom-launcher',
    '#intercom-container',
    // Match fixed position elements in bottom-right that might be widgets
  ];
  selectors.forEach(selector => {
    try {
      document.querySelectorAll(selector).forEach(el => {
        el.style.display = 'none';
        el.remove();
      });
    } catch (e) {}
  });
  
  // Also hide any fixed position elements in the bottom-right corner that look like widgets
  document.querySelectorAll('div, iframe').forEach(el => {
    const style = window.getComputedStyle(el);
    if (style.position === 'fixed' && 
        parseInt(style.bottom) < 100 && 
        parseInt(style.right) < 100 &&
        el.offsetWidth < 100 &&
        el.offsetHeight < 100) {
      el.style.display = 'none';
    }
  });
};

// Run on load and continuously for dynamically injected elements
if (typeof window !== 'undefined') {
  window.addEventListener('load', removeExternalWidgets);
  // Run multiple times to catch dynamically injected widgets
  [500, 1000, 2000, 3000, 5000].forEach(delay => {
    setTimeout(removeExternalWidgets, delay);
  });
  // Also run on any DOM mutations
  const observer = new MutationObserver(removeExternalWidgets);
  document.addEventListener('DOMContentLoaded', () => {
    observer.observe(document.body, { childList: true, subtree: true });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
